import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

import type { Commit } from "vuex";
import type { Customer } from "./types";
import type { Collection, Params } from "@/types/api";

interface State {
  customers: Collection<Customer>;
  customersAtRisk: Collection<Customer>;
}

const state: State = {
  customers: {
    current_page: 1,
    page_size: 5,
    results: [],
    total: 0,
  },
  customersAtRisk: {
    current_page: 1,
    page_size: 5,
    results: [],
    total: 0,
  },
};

export const getters = {
  customers: (state: State) => state.customers,
};

export const actions = {
  async getCustomers(
    { commit }: { commit: Commit },
    {
      globalOrganisationID,
      params,
    }: {
      globalOrganisationID: string | null;
      params: Params;
    },
  ) {
    if (globalOrganisationID === null) {
      throw new Error("Organisation ID is not provided");
    }

    const reqParams: Params = {};

    for (const [key, value] of Object.entries(params)) {
      reqParams[key] = value.toString().toLocaleLowerCase();
    }

    const searchParams = new URLSearchParams(reqParams);
    const res = await $http.get(
      `${getApiClientUrl()}/v1/cams/manager/${globalOrganisationID}/customers?${searchParams.toString()}`,
    );

    commit("setCustomers", res.data);
  },

  async getCustomersAtRisk(
    { commit }: { commit: Commit },
    {
      globalOrganisationID,
    }: {
      globalOrganisationID: string | null;
    },
  ) {
    if (globalOrganisationID === null) {
      throw new Error("Organisation ID is not provided");
    }

    const params = {
      status: "unprotected",
      results: -1,
    };

    const reqParams: Params = {};

    for (const [key, value] of Object.entries(params)) {
      reqParams[key] = value.toString().toLocaleLowerCase();
    }

    const searchParams = new URLSearchParams(reqParams);
    const res = await $http.get(
      `${getApiClientUrl()}/v1/cams/manager/${globalOrganisationID}/customers?${searchParams.toString()}`,
    );

    commit("setCustomersAtRisk", res.data);
  },
};

export const mutations = {
  setCustomers: (state: State, data: Collection<Customer>) =>
    (state.customers = data),
  setCustomersAtRisk: (state: State, data: Collection<Customer>) =>
    (state.customersAtRisk = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
